import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useSession } from '@/lib/auth/session';

const SITE_KEY = 'bomi.vendor.site';

function read(): string {
  try {
    return window.localStorage.getItem(SITE_KEY) ?? '';
  }
  catch {
    return '';
  }
}

function write(siteId: string): void {
  try {
    window.localStorage.setItem(SITE_KEY, siteId);
  }
  catch {
    // 기억하지 못해도 이번 화면은 정상으로 돈다.
  }
}

/**
 * 지금 보고 있는 현장 — <b>앱 전체가 같은 하나를 본다.</b>
 *
 * <h2>URL 이 진실이다</h2>
 * 경로에 `:siteId` 가 있으면 그것이 이긴다. 사용자가 링크를 받아 열거나 뒤로 가기를 눌렀을 때,
 * 화면은 A 현장인데 사이드바는 B 현장을 가리키는 상태가 생기면 안 된다. 그래서 URL 을 본
 * 순간 그것을 기억하고, 사이드바는 <b>기억한 값으로</b> 링크를 만든다.
 *
 * <h2>기억한 값은 목록을 받은 뒤에 확인한다</h2>
 * 배정이 끝났거나 다른 기기에서 열었으면 그 현장이 목록에 없다. 그때는 첫 현장으로 되돌린다 —
 * 확인하지 않으면 빈 화면이 뜨고, 사용자는 그것을 고장으로 읽는다.
 */
export function useSelectedSite() {
  const { siteId: fromUrl } = useParams();
  const session = useSession();
  const sites = session.data?.sites ?? [];

  const remembered = read();
  const current =
    sites.find((site) => site.id === fromUrl) ??
    sites.find((site) => site.id === remembered) ??
    sites[0];

  useEffect(() => {
    if (current !== undefined && current.id !== remembered) write(current.id);
  }, [current, remembered]);

  return {
    sites,
    current,
    partyType: session.data?.partyType ?? 'VENDOR',
    pending: session.isPending,
    choose: write,
  };
}
